import { SubscriptionStoreState, useSubscriptionStore } from '../subscriptionStore';

export const getHasHdWords = (state?: SubscriptionStoreState) => {
  const latestState = state ?? useSubscriptionStore.getState();
  if (latestState?.isLoading) return true;
  const hdWordsLeft = latestState.entitlements?.hdWordsLeft ?? 0;
  return hdWordsLeft > 0;
};
